import React from 'react';
import {firebase} from "../../../firebase/firebaseConfig";
var cloneDeep = require('lodash.clonedeep');

export default function TagSearch(props) {
  const handleClick = (e) => {
    const tag = e.target.innerText;

    //Checking if tag has been turned on or off
    if (props.activeTags[tag]) {
      let newTags = cloneDeep(props.activeTags);
      newTags[tag] = false;
      props.setActiveTags(newTags)

      //Analytics
      let selected = [];
      Object.keys(newTags).forEach((tag) => {
        if (newTags[tag]) selected.push(tag) });
      firebase.analytics().logEvent('industry_search', {industries: selected})
    } else {
      let newTags = cloneDeep(props.activeTags);
      newTags[tag] = true;
      props.setActiveTags(newTags);

      //Analytics
      let selected = [];
      Object.keys(newTags).forEach((tag) => {
        if (newTags[tag]) selected.push(tag) });
      firebase.analytics().logEvent('industry_search', {industries: selected})
    }
  }


  return (
    <div className="tagsContainer mt-5 px-2 pb-1">
      <p>Filter by industries</p>
      <ul>
        {Object.keys(props.activeTags).map(tag => {
          let classes = "btn btn-outline-success";
          if (props.activeTags[tag]) classes += " active";

          return (<li className="search-tag px-1" key={`tag_${Math.random()}`}>
            <button className={classes} onClick={handleClick}>{tag}</button>
          </li>)
          })
          }
      </ul>
    </div>
  )
}